import axios from 'axios';
import router from '@/router';
import { Message } from 'element-ui';


// export const getCsrfToken = () => {
//     const csrf = document.cookie.match('(^|;)\\s*csrftoken\\s*=\\s*([^;]+)');
//     return csrf ? csrf.pop() : '';
// };

export function get(url,params={}) {
    return new Promise(((resolve, reject) =>{
        axios.get(url, {
            // 传递参数
            params: params
            // 设置请求头信息，可以传递空值
        }).then(response => {
            if (response.data.code === 10004) {
                tokenExpired()
            }
            // 请求成功
             resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}


export function post(url,data={}) {
    return new Promise(((resolve, reject) =>{
        axios.post(url, data).then(response => {
            if (response.data.code === 10004) {
                tokenExpired()
            }
            // 请求成功
            resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}


export function patch(url,data={}) {
    return new Promise(((resolve, reject) =>{
        axios.patch(url,data).then(response => {
            // 请求成功
            resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}


export function put(url,data={}) {
    return new Promise(((resolve, reject) =>{
        axios.put(url,data).then(response => {
            if (response.data.code === 10004) {
                tokenExpired()
            }
            // 请求成功
            resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}

export function del(url,data={}) {
    return new Promise(((resolve, reject) =>{
        axios.delete(url,data).then(response => {
            if (response.data.code === 10004) {
                tokenExpired()
            }
            // 请求成功
            resolve(response.data)
        }).catch(error => {
            // 请求失败，
            reject(error)
        });
    } ))
}


function tokenExpired(){
    setTimeout(function () {
        router.push('/login');
    }, 2000);

    // Message({
    //     message: 'token失效,请重新登录!',
    //     type: 'error',
    //     duration: 2000
    // });
}

